export default __webpack_public_path__ + "static/media/santa-is-coming.fa69b751.png";